import React, { useEffect, useRef, useState } from "react";
import Uppersection from "./UpperSection/page";
import Leaderboard from "./Leaderboard/page";
import Header from "../Navbar/page";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Sidenavar from "../Navbar/sideNav/page";
import Footer from "../footer/page";
import { RingLoader } from "react-spinners";

function Page() {
  const location = useLocation();
  const [loading, setLoading] = useState(false)
  // console.log("location--->", location.state);
  const centerDivRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    // const load= setTimeout(()=> {
    //   // console.log("tiemssad")
    //   setLoading(false);
    // },3000);
    if (location.state && location.state?.msg === "User logged in successfully!") {
      let msg = location.state?.msg;
      toast(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    window.history.replaceState({}, document.title);
    // setLoading(false);
  }, [location]);

  useEffect(() => {
      // console.log("current div", centerDivRef.current);
   
      if (centerDivRef.current) {
        
        const parentDiv = centerDivRef.current.parentNode; // Access the parent div
  
        // Log or manipulate the parent div as needed
        if (parentDiv) {
          const grandParentDiv = parentDiv.parentNode;
          const grandGrandParentDiv = grandParentDiv.parentNode;
          const headerSection = parentDiv.querySelector(".header-section");
          const headerMenu = parentDiv.querySelector(".header-menu");
          const sidebar = grandGrandParentDiv.querySelector(
            ".sidebar.break-point-sm.has-bg-image"
          );
  
          if (headerSection) headerSection.style.display = "block";
          if (headerMenu) headerMenu.style.display = "block";
          if (sidebar) sidebar.style.display = "block";
        }
      }
    
    }, []);
  
  return (
    <>
      {/* <ToastContainer /> */}
      <div ref={centerDivRef}>
        {/* <div className="layout has-sidebar fixed-sidebar fixed-header">
          <Sidenavar />
          <div className="layout">
            <main className="content">
              <Header /> */}
        {/* {loading ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%" }}
        >
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <> */}
        <Header />
        <Uppersection />
        <Leaderboard />

        <Footer />
        {/* </>
      )} */}
      </div>
      {/* </main>
          </div>
        </div> */}
    </>
  );
}

export default Page;
